import { Grid, Typography } from "@mui/material";
import { Container, Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import BrowseSkillItem from "./BrowseSkillItem";
import { tokens } from "../../../store/tokens";
import { bodyText, heading } from "../../../store/presetsNew";

const gridContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.05 } },
};
const gridItem = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.35 } },
};

const BrowseSkill = ({ id }) => {
  const [skillsData, setSkillsData] = useState([]);

  useEffect(() => {
    fetch(`https://aps.songjukti.com/profile/login/api_webland/top_skill.php?eid=${id}`)
      .then((res) => res.json())
      .then((result) => {
        setSkillsData(result);
      })
      .catch((error) => {
        console.log("fetch skills Failed", error);
      });
  }, [id]);

  return (
    <Container sx={{ mt: { xs: 5, md: 6 }, mb: { xs: 5, md: 6 } }}>
      <Stack
        component={motion.div}
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5 }}
        justifyContent="center"
        alignItems="center"
        sx={{ textAlign: "center", gap: 1.25, mb: { xs: 3, md: 4 } }}
      >
        <Typography 
        sx={{ ...heading("h2"), fontSize: { xs: "1.7rem", md: tokens.type.h2.fontSize } }}
        >
          Browse skills and locations
        </Typography>
        <Typography sx={{ ...bodyText("body1"), maxWidth: 560 }}>
          Look for the best match for your skills and preferred locations
        </Typography>
      </Stack>

      <Grid
        container
        spacing={2}
        component={motion.div}
        variants={gridContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        {skillsData.map((element) => (
          <Grid item xs={6} sm={4} md={3} lg={2} key={element.refer} component={motion.div} variants={gridItem} whileHover={{ y: -3 }}>
            <BrowseSkillItem skillsData={element} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default BrowseSkill;